import { curry } from 'ramda';

import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId, IPublishTermsService } from '../../types/reducers/publishTerms';

export const selectServiceById = curry((serviceId: EServiceId, state: IAppState): IPublishTermsService | null => {
  const {
    publishTerms: { services },
  } = state.servicePickerWidget;

  return services[serviceId] || null;
});
